import * as React from "react";
import Nav from "./huskly/Nav";
import Hero from "./huskly/Hero";
import About from "./huskly/About";
import Projects from "./huskly/Projects";
import OpenSource from "./huskly/OpenSource";
import Manager from "./huskly/Manager";
import Footer from "./huskly/Footer";

const HusklyLandingApp = () => (
  <div className="min-h-screen bg-stone-50 text-stone-900 font-sans antialiased">
    <Nav />
    <main>
      <Hero />
      <About />
      <Projects />
      <OpenSource />
      <Manager />
    </main>
    <Footer />
  </div>
);

export default HusklyLandingApp;
